/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyGroupingRuleResponse {
    getFixupPrototypeFunction() { return CostAnomalyGroupingRuleResponse.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyGroupingRuleResponse>): CostAnomalyGroupingRuleResponse {
        let obj = Object.assign(new CostAnomalyGroupingRuleResponse(), model);
        CostAnomalyGroupingRuleResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyGroupingRuleResponse>): CostAnomalyGroupingRuleResponse {
        if (!model) return null;
        return CostAnomalyGroupingRuleResponse.newInstance(<CostAnomalyGroupingRuleResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyGroupingRuleResponse) {
        if (!obj) return;

        models.CostAnomalyGroupingRuleResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyGroupingRuleResponse): boolean {
        Object.setPrototypeOf(obj, CostAnomalyGroupingRuleResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.bill_date === "string") {
            this.bill_date = new Date(<string><any>this.bill_date);
        }
        if (this.anomaly_summary) {
            models.CostAnomalyGroupingRuleAggregate.fixupPrototype(this.anomaly_summary);
        }
        if (this.anomaly_details) {
            for (let val of this.anomaly_details) {
                models.CostAnomalyGroupingRuleDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * Dimension id
     */
    dimension_id: string;

    /**
     * Grouping rule id
     */
    grouping_rule_id: string;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

    /**
     * Bill date / day for this summary
     */
    bill_date: Date;

    /**
     * Aggregate anomaly summary for the grouping rule
     */
    anomaly_summary: models.CostAnomalyGroupingRuleAggregate;

    /**
     * List of individual anomalies under the grouping rule
     */
    anomaly_details: Array<models.CostAnomalyGroupingRuleDetail>;

    /**
     * Records based on the actual metric that is used during anomaly detection
     */
    billing_source: string;

}
